import { Component, Input, OnInit } from '@angular/core';
import * as ngswal from 'sweetalert';
import * as Highcharts from 'highcharts';
import { ConsecutivereportModel } from './consecutive-reportmodel';
import { ApiMethod } from '../apimethods/api-method';

@Component({
  selector: 'app-consecutive-report',
  templateUrl: './consecutive-report.component.html',
  styleUrls: ['./consecutive-report.component.css']
})
export class ConsecutivereportComponent implements OnInit {
  modelItem = new ConsecutivereportModel();

  @Input() chartTitle: string = '';
  @Input() data: any[] = []; // Input data like ametricsData1 or ametricsData2
  @Input() metricKey: string = 'Productivity'; // Metric column to show

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  groupedTableData: { department: string, rows: any[] }[] = [];
  constructor() { }

  ngOnInit(): void {
    this.loadConfig();
    this.buildChart();
    this.groupTableData();
  }

  loadConfig(): void {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = data['ConsecutivereportPage'] as ConsecutivereportModel;
      },
      error => {
        ngswal('Warning!', error.message || 'Failed to load config', 'warning');
      }
    );
  }
  groupTableData(): void {
    const grouped = this.groupByDepartment(this.data);
    this.groupedTableData = Object.entries(grouped).map(([department, rows]) => ({
      department,
      rows
    }));
  }

  buildChart(): void {
    const grouped = this.groupByDepartment(this.data);
    const categories = [...new Set(this.data.map(d => d.MonthName))];

    const series = Object.keys(grouped).map(dept => ({
      name: dept,
      type: 'areaspline' as const,
      data: categories.map(month => {
        const item = grouped[dept].find(r => r.MonthName === month);
        return item ? item[this.metricKey] : null;
      }),
      marker: { radius: 4 },
      fillOpacity: 0.4
    }));

    this.chartOptions = {
      chart: {
        type: 'areaspline',
        backgroundColor: '#fdfdfd'
      },
      title: {
        text: this.chartTitle,
        style: { fontSize: '18px' }
      },
      xAxis: {
        categories,
        title: { text: 'Month' },
        labels: { rotation: -45 },
        gridLineWidth: 1
      },
      yAxis: {
        title: { text: `${this.metricKey} %` },
        min: 0,
        max: 100,
        gridLineDashStyle: 'Dash'
      },
      tooltip: {
        shared: true,
        valueSuffix: '%',
        backgroundColor: '#ffffff',
        borderColor: '#ccc'
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      plotOptions: {
        areaspline: {
          fillOpacity: 0.3
        }
      },
      credits: { enabled: false },
      series
    };
  }


  groupByDepartment(data: any[]): Record<string, any[]> {
    return data.reduce((acc, item) => {
      const dept = item.Department;
      if (!acc[dept]) acc[dept] = [];
      acc[dept].push(item);
      return acc;
    }, {} as Record<string, any[]>);
  }
}
